import { Panel } from "components/Panel/Panel";
import { isBracketemDetails } from "model/PickemDetails/Bracketem/Details";
import { getBracketemPointsRulesText } from "model/PickemDetails/Bracketem/PointsRules";
import { isMatchemDetails } from "model/PickemDetails/Matchem/Details";
import { getMatchemPointsRulesText } from "model/PickemDetails/Matchem/PointsRules";
import {
  getDriverPicksFirstLine,
  getDriverPointsRulesText,
  PickemDetails,
} from "model/PickemDetails/PickemDetails";
import { isRankemDetails } from "model/PickemDetails/Rankem/Details";
import { getRankemPointRulesText } from "model/PickemDetails/Rankem/PointsRules";
import { DriverPointsInformation, PickemInformationContainer } from "./styles";

interface Props {
  pickemDetails: PickemDetails;
  header?: string;
}

export const PickemInformationPanel = ({ pickemDetails, header }: Props) => {
  const displayText = getDisplayText(pickemDetails);
  if (!displayText) {
    return <></>;
  }

  return (
    <Panel type="information" header={header}>
      <PickemInformationContainer>{displayText}</PickemInformationContainer>
    </Panel>
  );
};

const getDisplayText = (pickemDetails: PickemDetails) => {
  var predictLine = "";
  var pointsLine = "";
  if (isBracketemDetails(pickemDetails)) {
    predictLine = "Predict the winners for each match in the bracket.";
    pointsLine = getBracketemPointsRulesText(pickemDetails.pointsRules);
  } else if (isMatchemDetails(pickemDetails)) {
    predictLine = "Predict the winners for each match.";
    pointsLine = getMatchemPointsRulesText(pickemDetails.pointsRules);
  } else if (isRankemDetails(pickemDetails)) {
    predictLine = "Predict the place teams will finish.";
    pointsLine = getRankemPointRulesText(pickemDetails.pointsRules);
  }

  const driverPointsLine =
    pickemDetails.numDriverPicks > 0
      ? getDriverPointsRulesText(pickemDetails.driverPointsRules ?? [])
      : undefined;

  return (
    <>
      {predictLine}
      <br />
      {pointsLine}
      {!!driverPointsLine && (
        <DriverPointsInformation>
          <span>{getDriverPicksFirstLine(pickemDetails.numDriverPicks)}</span>
          <br />
          {driverPointsLine}
        </DriverPointsInformation>
      )}
    </>
  );
};
